import React, { useEffect, useState } from "react";
import { useSocket } from "../../../../../hooks/useSocket";
import { useTranslation } from "react-i18next";

interface OnlineStatusIndicatorProps {
  showText?: boolean;
  className?: string;
  isUserOnline: boolean;
  userId: string;
}

export const OnlineStatusIndicator: React.FC<OnlineStatusIndicatorProps> = ({
  showText = false,
  className = "",
  isUserOnline,
  userId,
}) => {
  const [onlineStatus, setOnlineStatus] = useState(isUserOnline);

  const { t } = useTranslation();

  const { presenceUsers } = useSocket();

  useEffect(() => {
    if (presenceUsers.has(userId)) {
      const userPresenceData = presenceUsers.get(userId);
      const updatedStatus = userPresenceData?.status === "online";

      setOnlineStatus(updatedStatus);
    }
  }, [userId, presenceUsers]);

  useEffect(() => {
    setOnlineStatus(isUserOnline);
  }, [isUserOnline]);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Online/Offline dot */}
      <div
        className={`w-2 h-2 rounded-full ${
          onlineStatus ? "bg-green-500" : "bg-gray-400"
        }`}
        title={onlineStatus ? t("online") : t("offline")}
      />

      {/* Status text */}
      {showText && (
        <span className="text-sm text-gray-600">
          {onlineStatus ? t("online") : t("offline")}
        </span>
      )}
    </div>
  );
};
